<template>
    <!-- Foooter -->
    <div class="max-w-screen-xl px-4 py-12 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8">
        <nav class="flex flex-wrap justify-center -mx-5 -my-2">
            <div class="px-5 py-2">
                <a href="#Présentation" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                    Présentation
                </a>
            </div>
            <div class="px-5 py-2">
                <a href="#Mon parcours" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                    Parcours
                </a>
            </div>
            <div class="px-5 py-2">
                <a href="#Mes projets" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                    Mes projets
                </a>
            </div>
            <div class="px-5 py-2">
                <a href="#Mes compétences" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                    Compétences
                </a>
            </div>
            <div class="px-5 py-2">
                <a href="#Contact" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                    Contact
                </a>
            </div>
        </nav>
        <p class="mt-8 text-base leading-6 text-center text-gray-400">
            © 2024 Stawski Maxime.
        </p>
        <p class="mt-8 text-base leading-6 text-center text-gray-400 italic">
            VueJS / TailwindCSS / Icon8 / Flatinon
        </p>
    </div>
</template>
<script>
export default {
    name: 'ComponentFooter',
}
</script>